/** Load optional controls when their markup exists, including later section inserts. */
const modules = new Map([
  ['product-sku-component', () => import('@theme/product-sku')],
  ['product-inventory', () => import('@theme/product-inventory')],
  ['show-more-component', () => import('@theme/show-more')],
  ['video-background-component', () => import('@theme/video-background')],
  ['rte-formatter', () => import('@theme/rte-formatter')],
  ['volume-pricing', () => import('@theme/volume-pricing')],
  ['price-per-item', () => import('@theme/price-per-item')],
  ['volume-pricing-info', () => import('@theme/volume-pricing-info')],
]);

function scan(root) {
  for (const [selector, load] of modules) {
    if (root.matches?.(selector) || root.querySelector(selector)) {
      // Remove before importing so a burst of section mutations only loads once.
      modules.delete(selector);
      load().catch((error) => {
        modules.set(selector, load);
        console.error(`Unable to load optional control ${selector}`, error);
      });
    }
  }
}

scan(document);
// A page without these controls can acquire them via quick add, filtering,
// recommendations or the editor. Inspect added subtrees, never rescan the page.
const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element) scan(node);
    }
  }
});
observer.observe(document.documentElement, { childList: true, subtree: true });
